
let href = '../../dynamic-data-mapping-form-field-type/js/api/FieldBase/FieldBase.(IhLdNPYyVBo).css';
if (window.getComputedStyle(document.documentElement).direction === 'rtl') {
	href = '../../dynamic-data-mapping-form-field-type/js/api/FieldBase/FieldBase_rtl.(IhLdNPYyVBo).css';
}

href = import.meta.resolve(href);
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute('href', href);
if (Liferay.CSP) {
	link.setAttribute('nonce', Liferay.CSP.nonce);
}
document.querySelector('head').appendChild(link);
